import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/global/ProtectedRoute';
import Products from '../pages/products/Products';
import CreateProduct from '../pages/products/CreateProduct';
import EditProduct from '../pages/products/EditProduct';

const productsRoutes = (
    <>
        {/* Products Routes */}
        <Route path="products" element={
            <ProtectedRoute requiredPermission="products.manage">
                <Products />
            </ProtectedRoute>
        } />

        <Route path="products/create" element={
            <ProtectedRoute requiredPermission="products.manage">
                <CreateProduct />
            </ProtectedRoute>
        } />

        <Route path="products/:id/edit" element={
            <ProtectedRoute requiredPermission="products.manage">
                <EditProduct />
            </ProtectedRoute>
        } />
    </>
);

export default productsRoutes;
